<div class="code-container overflow-hidden" [ngClass]="{ 'card shadow': displayAsCard }">
  <div class="header-5 code-container-title" [ngClass]="{ 'mb-0 p-2 is-card-view': displayAsCard, 'mb-1': !displayAsCard }"> {{ title }} </div>
  <div class="code-window"  [ngClass]="{ 'rounded-0 border-0': displayAsCard }">
    <pre class="w-100"><code [innerHTML]="formattedCode"></code></pre>
  </div>
</div>